export default "/images/ic-gen-card.svg?88d5954f3b159766a1f83b39a8fc60db";